import React from 'react';
import ReactPlayer from 'react-player';
import Header from './Header';
import GeneralGallery from './GeneralGallery';
import DetailGallery from './DetailGallery';
import BeautyGallery from './BeautyGallery';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Wrapper>
          <S.Title
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            raio-x de um
            <br />
            <span>desfile</span>
          </S.Title>
          <S.Subtitle
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Dries Van Noten | Verão 2022
          </S.Subtitle>
          <S.Author
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            POR LUIGI TORRE
            <br />
            <span>Fotos: Divulgação</span>
          </S.Author>
        </S.Wrapper>
        <S.Text>
          <p
            className="drop-caps wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O verão 2022 de Dries Van Noten é uma ode à liberdade e tudo que
            dela surge. A coleção funciona quase como um pout-pourri de paixões
            obsessões de seu criador. Quem acompanha seu trabalho sabe que suas
            ideias são contínuas, não exatamente repetitivas, mas recorrentes de
            estação em estação, como num meticuloso processo de evolução e
            aprimoramento.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Ao longo de seus mais de 35 anos carreira, Dries ficou conhecido por
            muitas coisas: como um dos integrantes dos Antwerp Six (um grupo de
            seis estilistas belgas que definiram um dos caminhos da moda nos
            anos 1990), pela sua habilidade excepcional em combinar e manipular
            cores, estampas, texturas e bordados, pelas referências
            multiculturais, pela alfaiataria oversized e a combinação de
            elementos couture com peças básicas do dia a dia.
          </p>
        </S.Text>
        <GeneralGallery />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Tudo isso aparece junto e misturado nas fotos do fotógrafo Rafael
            Pavarotti e no vídeo de Albert Moya – Dries achou que ainda não era
            o momento de voltar às passarelas. Nas cenas, ao som de trechos de
            hits de Grace Jones, as modelos interagem entre si, dançam, se
            soltam, se sentem. É uma coisa meio sonho, meio viagem alucinante e,
            ao mesmo tempo, bastante real. Quase como materialização imagética
            dos desejos e vontades comuns a muita gente.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Em comunicado à imprensa, o estilista explicou que a coleção é sobre
            momentos de alegria, uma celebração de cor, movimentos e toque. O
            ponto de partida, ou melhor, a inspiração inicial, são os festivais
            de música, festas, bares e buatchys, mas que se estende para
            qualquer encontro com amigos e pessoas. É sobre diversão
            compartilhada, sobre experiências, troca de sensações. Inclusive com
            aquilo que cobre nosso corpo.
          </p>
        </S.Text>
        <DetailGallery />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As roupas trazem uma profusão de cores saturadas, brilhos mil,
            bordados e texturas que gritam pelo toque. A construção é mais
            elaborada do que nas duas estações anteriores, com bastante
            alfaiataria, experimentação com volumes, superfícies e tingimentos.
            Fala com a vontade reprimida por uma moda mais arrumada, mais
            exuberante, mais viva. Não à toa a principal estampa é de fogos de
            artifício. Semiótica que chama.
          </p>
        </S.Text>
        <BeautyGallery />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A beleza acompanha o movimento de explosão, liberdade e êxtase.
            Maquiagem (assinada por Lucy Bridge) e cabelo (por Sam McKnight) são
            partes essenciais na construção de uma imagem carregada de
            sentimentos e emoções. São eles que dão profundidade e interpretação
            aos visuais: lembram elementos culturais, espirituais ou a ousadia e
            a exuberância que costumam brilhar mais sob a luz estroboscópica do
            que a solar.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Ao optar por apresentar a coleção longe das passarelas, Dries
            reconhece o desejo frustrado por uma boa montação e jogação e também
            o medo e a cautela. No vídeo, são frequentes as cenas de pausa ou
            movimentos em alusão a sustos, hesitação ou apreensão. Algo, aliás,
            que seria muito bem-vindo em alguns Réveillons contagiantes pelo
            Brasil e pelo mundo.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Mas de volta ao raio-x, há mais alguns detalhes a serem analisados
            na escolha e construção de imagens do estilista. Já na temporada
            anterior, a de inverno 2021, o designer acionou o mood performático
            para dar toda uma nova camada de sentidos e significados ao seu
            trabalho.
          </p>
        </S.Text>
        <S.VideoWrapper
          className="wow animate__animated animate__zoomIn"
          data-wow-duration="1s"
        >
          <ReactPlayer
            className="react-player"
            url="https://www.youtube.com/watch?v=vm0admU3848"
            width="100%"
            height="100%"
            controls
          />
        </S.VideoWrapper>
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            A apresentação aconteceu no teatro deSingel, na Antuérpia, e contou
            com 46 bailarinos e modelos dirigidos pelo fotógrafo Casper
            Sejersen. Os movimentos faziam referências à dançarina e coreógrafa
            Anne Teresa De Keersmaeker, que se destacou na cena da dança
            contemporânea na Bélgica na mesma época que Dries despontou como
            estilista.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Quando o vídeo foi ao ar, em março de 2021, a pandemia estava ainda
            mais fora do controle e as vacinas estavam apenas começando a ser
            distribuídas, e muito lentamente. A coleção foi toda feita sob as
            restrições e pesares dos piores momentos da crise da Covid-19, daí
            os sentimentos e movimentos de angústia, medo, desespero, breakdown,
            tudo meio limitado e ansioso por liberdade.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            As roupas acompanhavam o clima do momento: sóbrias, em tons
            apagados, sem muitos detalhes, sem extravagância, às vezes
            malvestidas ou cobrindo o corpo. "Em lockdown, movimentos são
            restritos. Você não pode sair, não pode ir dançar. Você também sente
            falta de contato – abraçar pessoas, ver amigos… A coisa toda. É uma
            vida estranha essa", disse Dries em entrevista à crítica de moda
            Cathy Horyn, no <i>The Cut</i>.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O verão 2022 segue a mesma cartilha, ainda que num tom mais
            otimista. Durante os meses de restrições mais severas, falou-se
            muito sobre novos formatos de apresentação. O audiovisual assumiu
            posição de destaque, porém foram raras as produções capazes de
            comunicar e evocar emoções e sentimentos tão distintos, latentes e
            conflituosos. Todos falaram sobre privações, desejos reprimidos,
            anseios libertários e movimento. Ainda assim, poucos entenderam a
            complexidade do momento. Menos ainda conseguiram traduzir esse
            tsunami de sensações em imagens e roupas.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Em 2017, o documentário Dries, do diretor Reiner Holzemer, faz uma
            imersão na vida e processo criativo do belga. Lá, o próprio
            estilista fala sobre seu perfeccionismo e obsessão por controle.
            Tais atributos, muitas vezes, funcionavam como filtros ou limites
            para suas vontades criativas e referências mil. Com a chegada da
            pandemia e todos seus baques, parece que rolou uma espécie de
            autoanálise e libertação de tais amarras.
          </p>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            O interesse pela dança, pela música, pelo hedonismo e pela
            permissividade da cena clubber fala sobre isso. São coisas que nos
            colocam em contato com nossos corpos, nossa mente, nossos
            sentimentos e outros seres humanos. São o que nos fazem sentir
            vivos. É como disse Pina Bausch: "Dance, senão estamos perdidos".
          </p>
        </S.Text>
        <S.Separator />
        <S.Text>
          <p
            className="wow animate__animated animate__fadeIn"
            data-wow-duration="1s"
            data-wow-delay="400ms"
          >
            Raio-X de um desfile é a uma seção fixa da ELLE View, em que todos
            os meses examinamos uma apresentação recente, trazendo detalhes
            sobre as roupas e explicando por que vale a pena você saber mais
            sobre ela.
          </p>
        </S.Text>
      </S.Content>
    </S.Container>
  );
};

export default Main;
